import Experience from '../experience/Experience.js'
import * as THREE from 'three';

export default class ChangeAnimation {
    constructor(world, fish, experience, renderer, camera, raycaster, sizes, time, controls, resources) {
        // this.cube = cube.cube; // Cube and fish are done like that because this.world.fish doesn't exist yet so it won't work without passing it through on ReadyState in Experience.js
        this.fish = fish.model.children[1]


        this.fishParent = fish
        this.fishOriginalY = this.fishParent.model.position.y; // Store the original position
        this.fishStartTime = 0; // Store the time when the animation starts
        this.totalElapsedTime = 0; // Total elapsed time for animation
        this.experience = experience;
        this.world = world;
        this.renderer = renderer
        this.scene = this.scene;
        this.raycaster = raycaster;
        this.resources = resources;
        this.sizes = sizes;
        this.camera = camera;
        this.time = time
        this.controls = controls
        this.isAnimatingCube = false;
        this.isAnimatingFish = false;
        this.mouse = new THREE.Vector2();

        this.addEventListeners();
        this.animate()
    }

    // toggleAnimation() {
    //     this.isAnimating = !this.isAnimating;
    // }

    animate() {
        requestAnimationFrame(() => this.animate());

        // Rotate the object (if needed)
        // if (this.isAnimatingCube) {
        //     this.cube.rotation.x += 0.01;
        //     this.cube.rotation.y += 0.01;
        // }

        // Rotate the object (if needed)
        if (this.isAnimatingFish) {
            // Drag fish
            // this.fish.position.y = this.mouse.y * 10
            // this.controls.enabled = false;
            // console.log(this.controls)

            // Change animation on click
            // this.animation = {}
            // this.animation.mixer = new THREE.AnimationMixer(this.resources.items.fishModel.scene)

            // this.animation.actions = {}

            // // console.log(this.resources.items.fishModel.animations)

            // this.animation.actions.transform = this.animation.mixer.clipAction(this.resources.items.fishModel.animations[0])
            // this.animation.actions.rotate = this.animation.mixer.clipAction(this.resources.items.fishModel.animations[1])
            // this.animation.actions.joel = this.animation.mixer.clipAction(this.resources.items.fishModel.animations[2])

            // this.animation.actions.current = this.animation.actions.transform
            // // this.animation.mixer.stopAllAction()
            // this.animation.actions.transform.play()
            // console.log(this.animation.actions['joel'])

            // console.log(this.animation.actions.current)

            // You can fade, crossfade, etc. between the animation (cool)
            // You can test that by using the console, window.experience.world.fox.animation.play('walking')
            // this.animation.play = (name) => {
            //     const newAction = this.animation.actions[name]
            //     const oldAction = this.animation.actions.current

            //     newAction.reset()
            //     newAction.play()
            //     newAction.crossFadeFrom(oldAction, 1)

            //     this.animation.actions.current = newAction
            // }

            // Animate fish
            // const elapsed = this.time.elapsed - this.fishStartTime;
            // this.totalElapsedTime += elapsed;
            // this.fishParent.model.position.y = this.fishOriginalY + 0.2 * Math.sin(this.totalElapsedTime / 200);
            // this.fishParent.model.position.x = this.fishParent.model.position.x + 0.008 * Math.sin(this.totalElapsedTime / 200);
            // // this.world.fox.model.position.y = this.fishOriginalY + 0.2 * Math.sin(this.totalElapsedTime / 200);
            // // console.log(this.experience.world)
            // this.fishStartTime = this.time.elapsed; // Reset the start time for the next frame

            // // Speed up fish on click
            // if (this.fishParent.animation.actions.current.timeScale >= 1 && this.fishParent.animation.actions.current.timeScale < 5) {
            //     this.fishParent.animation.actions.current.timeScale += elapsed / 100
            // }
        }

        // Slow down fish on second click
        if (!this.isAnimatingFish) {
            if (this.fishParent.animation.actions.current.timeScale > 1) {
                const elapsed2 = this.time.elapsed - this.fishStartTime;
                this.fishParent.animation.actions.current.timeScale -= elapsed2 / 1000
            }

            else {
                this.fishParent.animation.actions.current.timeScale = 1
            }
        }

        // Render the scene
        // this.renderer.instance.render(this.scene, this.camera);
    }

    addEventListeners() {
        window.addEventListener('mousemove', (event) => this.onMouseMove(event), false);
        window.addEventListener('click', (event) => this.onClick(event), false);
    }

    onMouseMove(event) {
        // Convert the mouse position to normalized device coordinates
        this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
        this.mouse.y = -(event.clientY / this.sizes.height) * 2 + 1;

        // Check for intersection with the object
        this.checkIntersection();
    }

    checkIntersection() {
        // Update raycaster with mouse and camera
        this.raycaster.setFromCamera(this.mouse, this.camera);

        // Get intersections
        // const intersects = this.raycaster.intersectObjects([this.cube]);
    }

    onClick(event) {
        // Only process events on the canvas
        if (event.target.tagName !== 'CANVAS') return;

        // Update raycaster with mouse and camera
        this.raycaster.setFromCamera(this.mouse, this.camera);

        // Get intersections
        // const intersectsCube = this.raycaster.intersectObjects([this.cube]);
        const intersectsFish = this.raycaster.intersectObjects([this.fish]);

        // Handle object click
        if (intersectsCube.length > 0) {
            this.handleCubeClick(intersectsCube[0].object);
        }

        // Handle fish click
        if (intersectsFish.length > 0) {
            this.handleFishClick(intersectsFish[0].object);
        }
    }

    handleCubeClick(object) {
        // Change color to blue on click
        // object.material.color.set(0x0000ff);
        // this.animate()
        this.isAnimatingCube = !this.isAnimatingCube;
    }

    handleFishClick(object) {
        // Change color to blue on click
        // object.material.color.set(0x0000ff);
        // this.animate()
        this.isAnimatingFish = !this.isAnimatingFish;

        if (this.isAnimatingFish) {
            this.fishStartTime = this.time.elapsed;
        } else {
            // this.controls.enabled = true;
            this.totalElapsedTime += this.time.elapsed - this.fishStartTime;
        }

        this.fishParent.switchAnimation();

    }
}
